import CommentsEmpty from './CommentsEmpty';

export default CommentsEmpty;
